export const initOptimizeSuite = (): void => {
  const config = window.Optimize.suiteData.config;
  window.OptimizeSuite.init(config);
  window.jQuery(() => {
    window.OptimizeSuite.initBloodhound();
  });
};
